module.exports = __webpack_public_path__ + "static/media/YF58_6.a085af73.jpg";